<template>
    <div
        class="w-full p-8 at1024:px-6 at1200:p-11 bg-gray-125 grid items-center print:hidden dark:bg-gray-875"
        :class="small ? 'grid-cols-1 gap-4' : 'grid-cols-2 gap-8'"
    >
        <img
            v-if="logo"
            :alt="logoAltText"
            :src="logo"
            class="mx-auto w-64 h-auto dark:bg-white"
        />
        <div class="w-full pt-4 text-sm mx-auto">
            <div v-if="phone" class="flex items-center gap-1">
                <BaseSvg
                    v-if="small"
                    name="icon-phone-chat"
                    class="w-4 h-4 shrink-0 fill-gray-800 dark:fill-gray-350"
                />
                <span v-else>{{ $t("Phone") }}</span>
                <span class="type-secondary">{{ phone }}</span>
            </div>
            <div v-if="website" class="flex items-center gap-1">
                <BaseSvg
                    v-if="small"
                    name="icon-earth-globe"
                    class="w-4 h-4 shrink-0 fill-gray-800 dark:fill-gray-350"
                />
                <span v-else>{{ $t("Website") }}</span>
                <a
                    :href="website"
                    target="_blank"
                    class="truncate type-secondary hover:type-primary hover:underline underline-offset-4"
                >
                    {{ website }}
                </a>
            </div>
        </div>
        <p v-if="tags" class="capitalize leading-snug text-sm">
            <span v-for="(tag, index) in tags"
                >{{ tag }}<span v-if="index !== tags.length - 1">, </span></span
            >
        </p>
    </div>
</template>

<script setup>
import { BaseSvg } from "@/Components";
import { useUser } from "@/Composables";
const { settings } = useUser();
const props = defineProps([
    "name",
    "logo",
    "logoAltText",
    "website",
    "phone",
    "small",
    "tags",
]);
</script>
